/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Plaintext/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'



/** @type {import('Simple/types.js').View} */
export default function Plaintext({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Template/NoteEditor/Content/ContentEditor/Plaintext",
  onChange
  
}) {
let noteTemplatesTabNoteTemplateContentValueData = fromData.useDataValue({ viewPath,
context: 'note_templates_tab',
path: 'note_template.content',
})
let noteTemplatesTabNoteTemplateContentChangeData = fromData.useDataChange({ viewPath,
context: 'note_templates_tab',
path: 'note_template.content',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={0}
 height={550}
 data="note_templates_tab.note_template.content"
 value={noteTemplatesTabNoteTemplateContentValueData}
 onChange={noteTemplatesTabNoteTemplateContentChangeData}
>
{childProps => (
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}